var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListValid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666855 6.52196C0.291365 6.08117 0.321185 5.42493 0.735105 5.02001C1.19911 4.56609 1.95301 4.60969 2.36159 5.11407L5.33333 8.78261L13.6158 0.759631C14.0523 0.336832 14.7461 0.338542 15.1805 0.763484C15.6301 1.20339 15.6301 1.92704 15.1805 2.36695L6.09915 11.2508C5.685 11.656 5.01431 11.6255 4.63862 11.1845L0.666855 6.52196Z",
    fill: "#96B000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListValid);
export default __webpack_public_path__ + "static/media/list-valid.927a0f6e7984f45a92d072c8338f7735.svg";
export { ForwardRef as ReactComponent };